/* NORAH · Avaliações · carrossel com troca automática (celular e computador) e botão "ver mais". */
(function () {
  var mqD = window.matchMedia('(min-width: 990px)');
  var mqM = window.matchMedia('(max-width: 749px)');
  var canHover = window.matchMedia('(hover: hover)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMore(root) {
    var btn = root.querySelector('.nr-rv__more');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var step = parseInt(btn.getAttribute('data-step'), 10) || 4;
      var hidden = root.querySelectorAll('.nr-rv__card[hidden]');
      for (var i = 0; i < hidden.length && i < step; i++) hidden[i].hidden = false;
      if (root.querySelectorAll('.nr-rv__card[hidden]').length === 0 && btn.parentNode) btn.parentNode.hidden = true;
    });
  }

  function initCarousel(root) {
    var grid = root.querySelector('.nr-rv__grid');
    if (!grid) return;
    var onD = root.getAttribute('data-desktop') === '1';
    var onM = root.getAttribute('data-mobile') === '1';
    var delay = (parseInt(root.getAttribute('data-autoplay'), 10) || 0) * 1000;
    var hover = false;
    var touching = false;
    var inView = true;
    var holdUntil = 0;
    var timer = null;

    function live() { return (onD && mqD.matches) || (onM && mqM.matches); }
    function hold() { holdUntil = Date.now() + delay; }
    function jump(x) {
      grid.style.transition = 'opacity 0.3s ease';
      grid.style.opacity = '0';
      setTimeout(function () {
        grid.style.scrollBehavior = 'auto';
        grid.scrollLeft = x;
        grid.style.scrollBehavior = '';
        grid.style.opacity = '1';
      }, 300);
    }
    function step(dir) {
      var card = grid.querySelector('.nr-rv__card:not([hidden])');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 20;
      var max = grid.scrollWidth - grid.clientWidth - 2;
      if (dir > 0 && grid.scrollLeft >= max) jump(0);
      else if (dir < 0 && grid.scrollLeft <= 2) jump(max);
      else grid.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
    function tick() {
      if (!root.isConnected) { clearInterval(timer); return; }
      if (!live() || document.hidden || !inView || hover || touching || Date.now() < holdUntil) return;
      step(1);
    }
    function start() {
      clearInterval(timer);
      if (delay && !reduce) timer = setInterval(tick, delay);
    }

    var arrows = root.querySelectorAll('.nr-rv__arrow');
    for (var a = 0; a < arrows.length; a++) {
      (function (b) {
        b.addEventListener('click', function () {
          step(parseInt(b.getAttribute('data-dir'), 10));
          hold();
          start();
        });
      })(arrows[a]);
    }
    if (canHover) {
      root.addEventListener('mouseenter', function () { hover = true; });
      root.addEventListener('mouseleave', function () { hover = false; hold(); });
      root.addEventListener('focusin', function () { hover = true; });
      root.addEventListener('focusout', function () { hover = false; });
    }
    grid.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    grid.addEventListener('touchend', function () { touching = false; hold(); }, { passive: true });
    grid.addEventListener('touchcancel', function () { touching = false; hold(); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }, { threshold: 0.25 }).observe(root);
    }
    start();
  }

  function initAll() {
    var roots = document.querySelectorAll('.nr-rv-section');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-ready')) continue;
      roots[i].setAttribute('data-ready', '1');
      initMore(roots[i]);
      initCarousel(roots[i]);
    }
  }

  window.nrRvInit = initAll;
  if (!window.nrRvBound) {
    window.nrRvBound = true;
    document.addEventListener('shopify:section:load', function () { window.nrRvInit(); });
  }
  initAll();
})();